import { useTranslation } from 'react-i18next'

import { FormFieldReadOnlyTextValue } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { TASK_FORM_FINISHED_FIELD_NAME } from '../../TaskForm.constants'

function FinishedField() {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={FormFieldReadOnlyTextValue}
      fieldComponentProps={{
        label: `${t('Task.FormFinishedFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={TASK_FORM_FINISHED_FIELD_NAME}
    />
  )
}

export default FinishedField
